import { Auth } from '@freelancer/auth';
import { map } from 'rxjs/operators';
import { LocalStorage } from './local-storage.service';

export const localStorageFactory = (auth: Auth) =>
  new LocalStorage(
    auth.authState$.pipe(
      map(authState => (authState ? authState.userId : undefined)),
    ),
  );
